<div [ngClass]="{'mobile-mode': sharedSvc.isMobileMode()}">
    <div class="pos-line-products-popup ">
        <div class="modal-body text-center f-s-18">
            <button class="btn close d-none" (click)="closeModal()"><i class="fa fa-times-circle-o"></i></button>
            <div class="products-carousel-wrapper">
                <products-carousel [item]="" [related]="data.POSLineProducts" type='promo'></products-carousel>
            </div>
            <div class="actions d-flex">
                <button class="btn btn-primary" (click)="closeModal()" translate>I am done</button>
            </div>
        </div>
    </div>
</div>
